import React, { useState }  from "react";

function Dropdown(props){
    const [status, setStatus] = useState(true);

    function changeStatus(){
        setStatus(!status)
    }

    return <>
        <div className="flex justify-center">
            <button type="button" onClick={changeStatus}
                className="flex items-center gap-2 bg-primary-500 text-white px-5 py-2.5 rounded-md shadow text-lg font-bold">
                {props.title !== undefined ? props.title : ""}
                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-gray-400" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path fillRule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clipRule="evenodd" />
                </svg>
            </button>

            {/* List */}
                <div  style={status ? {display:"none"} : {display:"block"}}
                    className="absolute w-60 mt-[50px] bg-white mx-auto rounded-md shadow-md">
                        {props.options !== undefined ?
                        props.options.map(item =>{
                            return <a href="#"  onClick={changeStatus}
                                className="flex items-center gap-2 w-full font-bold first-of-type:rounded-t-md last-of-type:rounded-b-md px-4 py-2.5 text-left text-sm hover:bg-gray-50 disabled:text-gray-500">
                                {item}
                            </a>
                        })
                        :
                        <a href="#" onClick={changeStatus}
                                className="flex items-center gap-2 w-full font-bold first-of-type:rounded-t-md last-of-type:rounded-b-md px-4 py-2.5 text-left text-sm hover:bg-gray-50 disabled:text-gray-500">
                                No element
                        </a>
                    }
                </div>

        </div>
    </>
}

export default Dropdown;